import { useRef } from 'react';
import _ from 'lodash';

var useEffectUnscoped = (callback, diffArray = [], deps) => {
  var ref = useRef();
  var depsRef = useRef();

  depsRef.current = deps;

  if (!ref.current || (diffArray.length && !_.every(diffArray, (item, index) => item === ref.current[index]))) {
    var callbackResult = callback(depsRef);

    ref.current = {callbackResult, diffArray};
  }
};

export default useEffectUnscoped;
